module.exports = __webpack_public_path__ + "static/media/discount_Icon.821cec60.webp";